import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { st, Modal, MainView, Form, FormControl, FormMessage, FormSection, Button, Message } from "lib/index";
import {
  stateSelector,
  validate,
  submit,
  setStep,
  closeIntegration,
  closeIntegrationWithoutDataErase,
  selectIntegrationServiceType,
} from "../PaymentsSettingsView/index";

class IntegrateOnlinePaymentsModalForm extends React.PureComponent {
  renderPayPalCredentialsInputs = ({ paypal_client_secret_key, paypal_client_api_key }) => {
    const { handleCompanyPropChange } = this.props;
    return (
      <div>
        <FormControl.TextAreaFormGroup
          key="paypal_client_api_key"
          value={paypal_client_api_key}
          onChange={(e) => handleCompanyPropChange("paypal_client_api_key", e.trim())}
          label={"Paypal client api key"}
          autoHeight
          // help={I18n.t("papp.settings.EditPaymentProfileModal.cancellation_policy_hint")}
        />
        <FormControl.TextAreaFormGroup
          key="paypal_client_secret_key"
          value={paypal_client_secret_key}
          onChange={(e) => handleCompanyPropChange("paypal_client_secret_key", e.trim())}
          label={"PayPal client secret key"}
          autoHeight
          // help={I18n.t("papp.settings.EditPaymentProfileModal.cancellation_policy_hint")}
        />
      </div>
    );
  };

  renderDotPayCredentialsInputs = ({ dotpay_account_id, dotpay_pin, dotpay_api_login, dotpay_api_password }) => {
    const { handleCompanyPropChange } = this.props;
    return (
      <div>
        <FormControl.TextAreaFormGroup
          key="dotpay_account_id"
          value={dotpay_account_id}
          onChange={(e) => handleCompanyPropChange("dotpay_account_id", e.trim())}
          label={"Account ID"}
          autoHeight
          // help={I18n.t("papp.settings.EditPaymentProfileModal.cancellation_policy_hint")}
        />

        <FormControl.TextAreaFormGroup
          key="dotpay_pin"
          value={dotpay_pin}
          onChange={(e) => handleCompanyPropChange("dotpay_pin", e.trim())}
          label={"DotPay Pin"}
          autoHeight
          // help={I18n.t("papp.settings.EditPaymentProfileModal.cancellation_policy_hint")}
        />
        <FormControl.TextAreaFormGroup
          key="dotpay_api_login"
          value={dotpay_api_login}
          onChange={(e) => handleCompanyPropChange("dotpay_api_login", e.trim())}
          label={"API login"}
          autoHeight
          // help={I18n.t("papp.settings.EditPaymentProfileModal.cancellation_policy_hint")}
        />

        <FormControl.TextAreaFormGroup
          key="dotpay_api_password"
          value={dotpay_api_password}
          onChange={(e) => handleCompanyPropChange("dotpay_api_password", e.trim())}
          label={"API password"}
          autoHeight
          // help={I18n.t("papp.settings.EditPaymentProfileModal.cancellation_policy_hint")}
        />
      </div>
    );
  };

  renderPaymentServiceChoice(serviceType, integrationServicesVersions, company) {
    const { handleCompanyPropChange, selectIntegrationServiceType } = this.props;
    const serviceTypeSettings = {
      paypal: this.renderPayPalCredentialsInputs(company),
      dotpay: this.renderDotPayCredentialsInputs(company),
    };
    return (
      <div>
        {!company.dotpay_access && !company.paypal_access ? (
          <FormControl.MultipleRadioFormGroup
            inlineLabel
            inline
            // {...FormControl.addProps(`${name}.payment_service_integration_type`, { errors }) }
            value={serviceType}
            onChange={selectIntegrationServiceType.bind(this)}
            // label={I18n.t("papp.components.ProductPricedOrderFieldFormSection.ask_customer")}
            label={"Choose service"}
            options={integrationServicesVersions}
            // readOnly={readOnlyAccess}
          />
        ) : (
          <h2>Edition of {company.dotpay_access ? "DotPay" : "PayPal"} credentials</h2>
        )}
        {serviceTypeSettings[serviceType]}
      </div>
    );
  }

  renderReviewServiceComponent(serviceType, company) {
    return (
      <div>
        <h2>Please, check if provided information is correct?</h2>
        {serviceType == "paypal" && (
          <div>
            <p>
              <b>PayPal client secret key:</b> {company.paypal_client_secret_key}
            </p>
            <p>
              <b>PayPal client API key:</b> {company.paypal_client_api_key}
            </p>
          </div>
        )}
        {serviceType == "dotpay" && (
          <div>
            <p>
              <b>Account ID:</b> {company.dotpay_account_id}
            </p>
            <p>
              <b>Pin:</b> {company.dotpay_pin}
            </p>
            <p>
              <b>API login:</b> {company.dotpay_api_login}
            </p>
            <p>
              <b>API password:</b> {company.dotpay_api_password}
            </p>
          </div>
        )}
      </div>
    );
  }

  renderPaymentIntegrationModalContent(step, serviceType, integrationServicesVersions, company) {
    const contents = {
      0: this.renderPaymentServiceChoice(serviceType, integrationServicesVersions, company),
      1: this.renderReviewServiceComponent(serviceType, company),
    };
    return contents[step];
  }

  render() {
    const { profile, valid, errors, loading, onValidate, step, serviceType, company } = this.props;
    return (
      <Form error={!valid} loading={loading}>
        {this.renderPaymentIntegrationModalContent(step, serviceType, integrationServicesVersions, company)}
      </Form>
    );
  }
}

const integrationServicesVersions = [
  // ["assignation_per_order", I18n.humanAttributeName("product_order_field", "assignation_per_order")],
  // ["assignation_per_person", I18n.humanAttributeName("product_order_field", "assignation_per_person")],
  ["paypal", "Paypal"],
  ["dotpay", "Dotpay"],
  ["payu", "PayU"],
];
@connect(
  (state) => ({
    opened: stateSelector(state).opened_integration,
    profileId: stateSelector(state).profileId,
    company: stateSelector(state).form.model,
    serviceType: stateSelector(state).serviceType,
    step: stateSelector(state).step,
    valid: stateSelector(state).form.valid,
    errors: stateSelector(state).form.errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        closeIntegration,
        setStep,
        selectIntegrationServiceType,
        closeIntegrationWithoutDataErase,
        validate,
        submit,
      },
      dispatch
    )
)
export default class IntegrateOnlinePaymentsModal extends React.PureComponent {
  handleSubmit() {
    this.props.submit();
    this.props.closeIntegrationWithoutDataErase();
  }

  setFormStep(step) {
    this.props.setStep(step);
  }

  renderPaymentIntegrationModalHeader(step, { dotpay_access, paypal_access }) {
    const headers = {
      0: dotpay_access || paypal_access ? "Edition of integrated service" : "Addition of integrated service",
      1: "Review of integrated service",
    };
    return headers[step];
  }

  renderPaymentIntegrationModalActions(
    step,
    serviceType,
    {
      paypal_client_secret_key,
      paypal_client_api_key,
      dotpay_account_id,
      dotpay_pin,
      dotpay_api_login,
      dotpay_api_password,
    }
  ) {
    const actions = {
      0: (
        <Button
          as="a"
          primary
          onClick={() => this.setFormStep(1)}
          disabled={
            serviceType == "paypal"
              ? !paypal_client_secret_key || !paypal_client_api_key
              : !dotpay_account_id || !dotpay_pin || !dotpay_api_login || !dotpay_api_password
          }
        >
          {I18n.t("papp.common.go_next")}
        </Button>
      ),
      1: (
        <div>
          <Button as="a" floated="left" basic onClick={() => this.setFormStep(0)}>
            {I18n.t("papp.common.go_back")}
          </Button>
          <Button as="a" primary onClick={this.handleSubmit.bind(this)}>
            {I18n.t("papp.common.save")}
          </Button>
        </div>
      ),
    };

    return actions[step];
  }
  render() {
    const { company, closeIntegration, opened, step, serviceType, handleCompanyPropChange } = this.props;
    return (
      opened && (
        <Modal size="small" closeIcon closeOnDimmerClick={false} open onClose={() => closeIntegration()}>
          <Modal.Header>{this.renderPaymentIntegrationModalHeader(step, company)}</Modal.Header>
          <Modal.Content>
            <IntegrateOnlinePaymentsModalForm
              step={step}
              company={company}
              setFormStep={this.setFormStep}
              serviceType={serviceType}
              closeIntegration={closeIntegration}
              handleCompanyPropChange={handleCompanyPropChange}
              selectIntegrationServiceType={this.props.selectIntegrationServiceType}
            />
          </Modal.Content>
          <Modal.Actions>{this.renderPaymentIntegrationModalActions(step, serviceType, company)}</Modal.Actions>
        </Modal>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/IntegrateOnlinePaymentsModal/IntegrateOnlinePaymentsModal.jsx